const QUOTE_ID_KEY = "quoteID";

export const getQuoteIDFromSession = (spaceOrMembershipID?: string) => {
  if (spaceOrMembershipID) {
    return (
      sessionStorage.getItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`) ||
      undefined
    );
  }

  return undefined;
};

export const setQuoteIDToSession = (
  quoteID?: string,
  spaceOrMembershipID?: string
) => {
  const currentQuoteID = getQuoteIDFromSession(spaceOrMembershipID);

  if (quoteID && quoteID !== currentQuoteID) {
    sessionStorage.setItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`, quoteID);
  }
};

export const removeQuoteIDFromSession = (spaceOrMembershipID?: string) => {
  if (spaceOrMembershipID) {
    sessionStorage.removeItem(`${QUOTE_ID_KEY}_${spaceOrMembershipID}`);
  }
};
